module.exports = __webpack_public_path__ + "static/media/microcentrifuge_topview_lid_closed.c5427a23.svg";